module.exports = __webpack_public_path__ + "img/nt112-07-85-1.prt.88e2b409.jpg";